import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
const myElement = document.querySelector('nav.sticky-top');
const section = document.querySelector('.container');

window.onresize = checkWindowSize;
window.onload = checkWindowSize;
const windowBreakpoint = 991;

function checkWindowSize() {
    let myWidth = window.innerWidth;
    // if (myWidth >= windowBreakpoint) {}
    gsapAnimations();
};


const subMenuAddDistance = () => {
    const subMenu = document.querySelectorAll('.nav--top-menu__level-1');
    subMenu.forEach(item => {
        item.style.top = 'calc(100% + 20px)';
    });
}
const subMenuRemoveDistance = () => {
    const subMenu = document.querySelectorAll('.nav--top-menu__level-1');
    subMenu.forEach(item => {
        item.style.top = '100%';
    });
}

const gsapAnimations = () => {
    const bgColorAnimation = gsap.to(myElement, {
        backgroundColor: 'rgba(26,25,141,0.6)',
        paddingBottom: '10px',
        paddingTop: '10px',
        backdropFilter: 'blur(7px)',
        duration: 0.2, 
        paused: true, 
        ease: 'Power1.easeIn'
    });
  

    ScrollTrigger.create({
        // markers: true,
        trigger: section, 
		start: 'top 0%',
        onEnter: () => (bgColorAnimation.play(),subMenuAddDistance()), 
        onLeaveBack: () => (bgColorAnimation.reverse(), subMenuRemoveDistance()),
    });
}
